import React from 'react';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { MechanismSection } from '../components/MechanismSection';
import { EvidenceSection } from '../components/EvidenceSection';
import { TrainingSection } from '../components/TrainingSection';
export function VabysmoLanding() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-teal-500 selection:text-white" data-id="element-190">
      <Navigation data-id="element-191" />
      <main data-id="element-192">
        <HeroSection data-id="element-193" />
        <MechanismSection data-id="element-194" />
        <EvidenceSection data-id="element-195" />
        <TrainingSection data-id="element-196" />
      </main>

      <footer className="bg-slate-900 text-slate-400 py-12 border-t border-slate-800" data-id="element-197">
        <div className="container mx-auto px-4 text-center" data-id="element-198">
          <p className="text-sm mb-4" data-id="element-199">
            © {new Date().getFullYear()} Vabysmo (faricimab-svoa). All rights
            reserved.
          </p>
          <p className="text-xs max-w-2xl mx-auto leading-relaxed opacity-60" data-id="element-200">
            Vabysmo is a registered trademark of Genentech, Inc. This website is
            for educational purposes only intended for US healthcare
            professionals. Please see full Prescribing Information for Important
            Safety Information.
          </p>
        </div>
      </footer>
    </div>;
}